import React, { useState } from 'react';
import Section from '../ui/Section';
import Heading from '../ui/Heading';
import Button from '../ui/Button';
import DownloadFormPopup from '../ui/DownloadFormPopup';
import img2 from '../../assets/exterior/vasudharinihomes_exterior_11.png';
import img3 from '../../assets/exterior/vasudharinihomes_exterior_8.png';
import img1 from '../../assets/interior/vasudharinihomes_interior_20.png';
import img4 from '../../assets/interior/vasudharinihomes_interior_21.png';
import nest_brochure from '../../assets/vasudharini_nest.pdf'
import { FaFilePdf } from "react-icons/fa6";

const ProjectOverview = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  
  const handleDownloadClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const downloadBrochure = async (formData) => {
    setIsDownloading(true);
    
    try {
      // Form data has already been submitted to Web3Forms in the popup component
      console.log('User details submitted to Web3Forms:', formData);

      const response = await fetch(nest_brochure);
      const blob = await response.blob();
      
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'vasudharini_nest.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Close popup after successful download
      setIsPopupOpen(false);
      
      // Optional: Show success message
      // alert('Thank you! Your details have been submitted and the brochure is being downloaded.');
      
    } catch (error) {
      console.error('Failed to download brochure:', error);
      alert('Sorry, there was an error downloading the brochure. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <Section className='sm:px-5 lg:px-10 sm:py-20'>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            {/* <span className="bg-yellow-400 text-black font-bold py-2 px-3 rounded-full text-sm mb-4 inline-block">
              FEATURED PROJECT
            </span> */}
            <Heading level={2}>Vasudharini Nest</Heading>
            
            <p className="text-gray-700 mb-6 sm:text-lg">
              Vasudharini Nest is our flagship residential project located in the rapidly developing Sarjapur 
              area of Bengaluru. The project features impressive Spanish architecture with arcaded balconies 
              and corridors with arches that intensify the beauty of this development.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <div className="bg-yellow-100 p-2 rounded-full mr-4">
                  <svg className="h-6 w-6 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Prime Location</h3>
                  <p className="text-gray-600">
                    Located in Sarjapur, one of the important addresses in southeastern Bengaluru, with proximity to 
                    educational institutions, tech parks, healthcare centers, and markets.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="bg-yellow-100 p-2 rounded-full mr-4">
                  <svg className="h-6 w-6 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Spanish Architecture</h3>
                  <p className="text-gray-600">
                    The project has an impressive Spanish architecture with arcaded balconies and corridors with 
                    arches that intensify the beauty of this development.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex space-x-4">
              <Button to="/contact" variant="outlinePrimary">Book a Site Visit</Button>
              <Button onClick={handleDownloadClick} variant="secondary" className="gap-2 flex">
                Download Brochure
                <FaFilePdf size={18} />
              </Button>
            </div>
          </div>
          
          {/* Innovative Image Gallery Design - All Images Visible */}
          <div className="relative h-96 sm:h-128 w-full">
            {/* Main large image */}
            <div className="absolute top-0 left-0 w-3/5 h-3/5 z-10">
              <img 
                src={img1} 
                alt="Vasudharini Nest Exterior" 
                className="w-full h-full object-cover border-4 border-white"
              />
            </div>
            
            {/* Overlapping small image top right */}
            <div className="absolute top-8 right-0 w-2/5 h-2/5 z-20">
              <img 
                src={img2} 
                alt="Vasudharini Nest Interior" 
                className="w-full h-full object-cover border-4 border-white"
              />
            </div>
            
            {/* Bottom right medium image */}
            <div className="absolute bottom-0 right-0 w-2/5 h-3/5 z-10">
              <img 
                src={img3} 
                alt="Vasudharini Nest Amenities" 
                className="w-full h-full object-cover border-4 border-white"
              />
            </div>
            
            {/* Bottom left overlapping image */}
            <div className="absolute bottom-4 left-16 w-2/5 h-2/5 z-20">
              <img 
                src={img4} 
                alt="Vasudharini Nest View" 
                className="w-full h-full object-cover border-4 border-white"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 border-4 border-yellow-400 z-0"></div>
            <div className="absolute bottom-6 right-12 w-16 h-16 bg-gray-100 z-0"></div>
            
            {/* Added decorative elements */}
            <div className="absolute top-6 left-12 w-4 h-4 bg-yellow-400 z-0 opacity-50"></div>
            <div className="absolute top-1/4 right-1/4 w-6 h-6 rounded-full border-2 border-dashed border-gray-300 z-0"></div>
            <div className="absolute bottom-12 left-1/3 w-10 h-10 border-2 border-gray-200 transform rotate-45 z-0"></div>
            <div className="absolute bottom-20 right-24 w-3 h-12 bg-yellow-200 opacity-40 z-0"></div>
            <div className="absolute top-1/2 right-1/3 w-5 h-5 bg-gray-100 transform rotate-12 z-0"></div>
            <div className="absolute top-3/4 left-1/2 w-20 h-px bg-yellow-400 z-0 opacity-30"></div>
            
            {/* Diagonal lines */}
            <div className="absolute top-1/3 right-0 w-16 h-px bg-gray-200 transform rotate-45 z-0"></div>
            <div className="absolute bottom-1/4 left-8 w-16 h-px bg-gray-200 transform -rotate-45 z-0"></div>
            
            {/* Corner accents for image layout */}
            <div className="absolute -top-2 -left-2 w-4 h-4 border-t border-l border-yellow-400 z-30"></div>
            <div className="absolute -top-2 -right-2 w-4 h-4 border-t border-r border-yellow-400 z-30"></div>
            <div className="absolute -bottom-2 -left-2 w-4 h-4 border-b border-l border-yellow-400 z-30"></div>
            <div className="absolute -bottom-2 -right-2 w-4 h-4 border-b border-r border-yellow-400 z-30"></div>
          </div>
        </div>
      </Section>

      {/* Download Form Popup */}
      <DownloadFormPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        onDownload={downloadBrochure}
        title="Download Vasudharini Nest Brochure"
        downloadText="Download Brochure"
        isLoading={isDownloading}
      />
    </>
  );
};

export default ProjectOverview;